module.exports = __webpack_public_path__ + "img/success@2x.517de540.png";